import Vue from "vue";

export const apiDelete = async (url, { ...data }) => {
  return await Vue.axios
    .delete(url, { ...data })
    .then(res => {
      return Promise.resolve(res.data);
    })
    .catch(error => {
      throw error;
    });
};
